<div class="clug-form-modal" *ngIf="editJobAssignment" [formGroup]="editJobAssignment">
  <div class="clug-form-modal-loader" *ngIf="loading">
    <div class="auth-spinner" aria-label="Loading"></div>
  </div>

  <div class="modal-head">
    <div class="title-block">
      <h2>Edit Assignment</h2>
      <span class="sub">Update the candidate, approvers or work period on this assignment.</span>
    </div>
    <button type="button" class="close-btn" title="Close" (click)="onClose()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <div class="modal-body tight">

    <div class="meta-strip">
      <div class="item" *ngIf="assignment?.start_date">
        <span class="k">Period</span>
        <span class="v">
          {{ assignment.start_date | date: 'd MMM' }} – {{ assignment.end_date | date: 'd MMM y' }}
        </span>
      </div>
      <div class="divider" *ngIf="assignment?.start_date"></div>
      <div class="item">
        <span class="k">Candidate</span>
        <span class="v">{{ assignment?.candidate }}</span>
      </div>
      <span class="status-pill" *ngIf="assignment?.active !== 0">
        <i class="bi bi-check-circle-fill"></i>Active
      </span>
    </div>

    <div class="form-section">
      <div class="form-section-head">
        <span class="title">
          <span class="ico"><i class="bi bi-layout-text-window-reverse"></i></span>Assignment
        </span>
        <span class="req-pill">Required</span>
      </div>

      <div class="grid-2">
        <div class="field tight">
          <label>Job <span class="req">*</span></label>
          <input formControlName="assignment_uuid" style="display: none;" />
          <input formControlName="job_uuid" style="display: none;" />
          <input type="text" class="input-form" formControlName="job_name" readonly />
        </div>

        <div class="field tight">
          <label>Candidate <span class="req">*</span></label>
          <input formControlName="candidate_uuid" style="display: none;" />
          <input type="text" class="input-form" formControlName="candidate_name" readonly />
        </div>

        <div class="field tight full">
          <label>Timesheet approvers <span class="req">*</span></label>
          <div class="chip-input" (click)="focusApproverInput($event)">
            <span class="chip" *ngFor="let uuid of selectedApproverUuids">
              {{ getApproverName(uuid) }}
              <button type="button" title="Remove" (click)="removeApprover(uuid, $event)">
                <i class="bi bi-x"></i>
              </button>
            </span>
            <input
              #approverInput
              type="text"
              [(ngModel)]="approverSearch"
              [ngModelOptions]="{standalone: true}"
              [placeholder]="selectedApproverUuids.length ? '' : 'Add approver…'"
              (focus)="approverDropdownOpen = true"
              (input)="approverDropdownOpen = true"
              (blur)="onApproverBlur()" />

            <div class="chip-dropdown" *ngIf="approverDropdownOpen && filteredApprovers.length">
              <div class="chip-option" *ngFor="let a of filteredApprovers"
                (mousedown)="addApprover(a.uuid, $event)">
                <span class="ic">{{ getApproverInitials(a.name) }}</span>
                <span>{{ a.name }}</span>
              </div>
            </div>
            <div class="chip-dropdown" *ngIf="approverDropdownOpen && !filteredApprovers.length && availableApprovers.length">
              <div class="chip-empty">No matching approvers.</div>
            </div>
          </div>
          <span class="hint">Pick from this client's contacts.</span>
        </div>

        <div class="field tight full">
          <label>Period <span class="req">*</span></label>
          <div class="daterange" (click)="picker.open()"
            [class.invalidField]="(editJobAssignment?.controls['start_date']?.errors && editJobAssignment?.controls['start_date']?.touched) || (editJobAssignment?.controls['end_date']?.errors && editJobAssignment?.controls['end_date']?.touched)">
            <i class="bi bi-calendar4"></i>
            <mat-date-range-input [rangePicker]="picker" [disabled]="!editJobAssignment?.value?.assignment_uuid"
              [min]="minLimit" [max]="maxLimit">
              <input matStartDate formControlName="start_date" />
              <input matEndDate formControlName="end_date" />
            </mat-date-range-input>
            <mat-datepicker-toggle [for]="picker" style="display:none;"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </div>
        </div>
      </div>
    </div>

    <div class="form-error" *ngIf="error">
      <i class="bi bi-exclamation-triangle-fill"></i>
      <span>{{ error }}</span>
    </div>
  </div>

  <div class="modal-foot">
    <div class="left">
      <button type="button" class="btn btn-danger-ghost" (click)="onDeleteAssignment()" [disabled]="loading">
        <i class="bi bi-trash"></i>Deactivate assignment
      </button>
    </div>
    <div class="right">
      <button type="button" class="btn btn-secondary" (click)="onClose()">Cancel</button>
      <button type="submit" class="btn btn-primary" [disabled]="loading"
        (click)="onSubmit()">
        <i class="bi bi-check-lg"></i>Save changes
      </button>
    </div>
  </div>
</div>
